import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SideBar from "../components/SideBar";
import axios from "axios";

export default function MultiShipmentUpdater() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [statusID, setStatusID] = useState(0);
  const [reasonID, setReasonID] = useState(0);
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);
  const [recipientCategoryID, setRecipientCategoryID] = useState(0);
  const [statusList, setStatusList] = useState([]);
  const [reasonList, setReasonList] = useState([]);
  const [recipientCategories, setRecipientCategories] = useState([]);
  const [awbListText, setAwbListText] = useState("");
  const [loading, setLoading] = useState(false);
  const [updateNotes, setUpdateNotes] = useState("");

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const runnerID = userData.runnerID;

        const res = await axios.get(
          `https://vsoftrunners.com-eg.net/api/RunnerUsers/V7/GetRunnerData/${runnerID}`,
          {
            headers: {
              CompanyID: "212606",
              AccessToken: userData.accessToken,
            },
          }
        );

        const deliveryStatuses = res.data.deliveryStatuses || [];
        const customDeliveredStatus = { statusId: 5, fNameA: "تم التوصيل" };
        const combinedStatuses = [customDeliveredStatus, ...deliveryStatuses];

        setStatusList(combinedStatuses);
        setReasonList(res.data.reasons || []);
        setRecipientCategories(res.data.recipients || []);

        // 🟢 تخزين الشحنات في localStorage
        if (res.data.shipments) {
          localStorage.setItem(
            "withRunnerShipments",
            JSON.stringify(res.data.shipments)
          );
        }
      } catch (error) {
        console.error("فشل تحميل الخيارات:", error);
        alert("حدث خطأ أثناء تحميل البيانات");
      }
    };

    fetchOptions();
  }, []);

  const handleUpdate = async () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const allShipments = JSON.parse(
      localStorage.getItem("withRunnerShipments") || "[]"
    );

    const selectedShipments = awbListText
      .split(/\n|,/)
      .map((awb) => awb.trim())
      .filter((awb) => awb)
      .map((awb) =>
        allShipments.find((s) => String(s.awb).trim() === String(awb).trim())
      )
      .filter(Boolean); // remove not found

    if (!statusID || selectedShipments.length === 0) {
      alert("يرجى اختيار الحالة وإدخال أرقام شحنات صحيحة");
      return;
    }

    const payload = {
      shipments: selectedShipments.map((s) => ({
        awb: s.awb,
        statusID,
        reasonID: statusID === 5 ? 0 : reasonID,
        lat: 0,
        lon: 0,
        jsonData: "",
        deliveryDate: new Date().toISOString(),
        recipientID: statusID === 5 ? recipientCategoryID : 0,
        recipientName: "",
        updateNotes: updateNotes || "",
        idno: "",
        collectedValue: statusID === 5 ? s.cod : 0,
        awBvsAWB: false,
      })),
      pickups: [],
      commLogs: [],
      locationTracks: [],
    };

    try {
      setLoading(true);
      const runnerID = userData.runnerID;
      await axios.post(
        `https://vsoftrunners.com-eg.net/api/RunnerUsers/V7/UpdateRunnerData/${runnerID}`,
        payload,
        {
          headers: {
            CompanyID: "212606",
            AccessToken: userData.accessToken,
          },
        }
      );
      alert("تم تحديث الشحنات بنجاح");
      setAwbListText("");
    } catch (error) {
      console.error("فشل التحديث:", error);
      alert("حدث خطأ أثناء التحديث");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <SideBar
        open={isSideBarOpen}
        toggleOpen={() => setIsSideBarOpen(!isSideBarOpen)}
      />
      <Box
        sx={{
          height: "calc(100vh - 180px)",
          width: "95%",
          marginTop: "70px",
          marginLeft: isRTL ? undefined : isSideBarOpen ? "50px" : "250px",
          marginRight: isRTL ? (isSideBarOpen ? "50px" : "250px") : undefined,
          transition: "margin-left 0.3s, margin-right 0.3s",
        }}
      >
        <Typography variant="h5" mb={2} fontWeight="bold">
          تحديث شحنات متعددة
        </Typography>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>اختر الحالة</InputLabel>
          <Select
            value={statusID}
            label="اختر الحالة"
            onChange={(e) => setStatusID(Number(e.target.value))}
          >
            <MenuItem value={0} disabled>
              -- اختر الحالة --
            </MenuItem>
            {statusList.map((s) => (
              <MenuItem key={s.statusId} value={s.statusId}>
                {s.fNameA}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {statusID === 5 && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>فئة المستلم</InputLabel>
            <Select
              value={recipientCategoryID}
              label="فئة المستلم"
              onChange={(e) => setRecipientCategoryID(Number(e.target.value))}
            >
              {recipientCategories.map((cat) => (
                <MenuItem key={cat.recipientId} value={cat.recipientId}>
                  {cat.fNameA}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {statusID !== 0 && statusID !== 5 && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>اختر السبب</InputLabel>
            <Select
              value={reasonID}
              label="اختر السبب"
              onChange={(e) => setReasonID(Number(e.target.value))}
            >
              {reasonList.map((r) => (
                <MenuItem key={r.reasonId} value={r.reasonId}>
                  {r.fNameA}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <TextField
          label="أرقام الشحنات (مفصولة بفواصل أو أسطر)"
          multiline
          rows={6}
          fullWidth
          value={awbListText}
          onChange={(e) => setAwbListText(e.target.value)}
          sx={{ mb: 3 }}
        />

        {statusID !== 5 && (
          <TextField
            label="ملاحظات"
            multiline
            rows={3}
            fullWidth
            value={updateNotes}
            onChange={(e) => setUpdateNotes(e.target.value)}
            sx={{ mb: 3 }}
          />
        )}

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleUpdate}
          disabled={loading || !statusID}
        >
          {loading ? "جاري التحديث..." : "شحنات متعددة"}
        </Button>
      </Box>
    </Box>
  );
}
